import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagCH = function FlagCH() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
    fill: "#D80027",
    d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F0F0F0",
    d: "M38.044 20.652H29.35v-8.696h-8.696v8.696h-8.695v8.696h8.695v8.695h8.696v-8.695h8.695v-8.696Z"
  }));
};
FlagCH.displayName = 'FlagCH';
export default withFlagWrapper(FlagCH);
//# sourceMappingURL=index.js.map